//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import { Stack } from '@mui/system';
import ModalSiteADelete from '../Modal/Delete/ModalSiteADelete';
import ModalSiteAUpdate from '../Modal/Update/ModalSiteAUpdate';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { GlobalVariables } from '../../globalVar';

import ModalSiteA from '../Modal/Create/ModalSiteA';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const SiteAssetsTableAxios = () => {
  const [siteAssetData, setSiteAssetData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const {
    siteStatusString,
    visitUDateString,
    addString,
    detailString,
    editString,
    deleteString,
    assetsString,
  } = useTranslationHook();

  useEffect(() => {
    const updateSiteAData = () => {
      setSiteAssetData((prevData) => {
        return prevData.map((asset) => ({
          ...asset,
          is_active: t(`${asset.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateSiteAData);

    return () => {
      i18next.off('languageChanged', updateSiteAData);
    };
  }, [t]);

  var siteId = localStorage.getItem('siteIdForUpdate');

  const endpoint = `${GlobalVariables.getURL()}listAssetsFromSite/${siteId}`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const siteAssetData = response.data.map((asset) => {
        return {
          ...asset,
          is_active: t(`${asset.is_active}`),
        };
      });
      setSiteAssetData(siteAssetData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const [modalSiteAShow, setModalSiteAShow] = useState(false);
  const [modalSiteADeleteShow, setModalSiteADeleteShow] = useState(false);
  const [modalSiteAUpdateShow, setModalSiteAUpdateShow] = useState(false);

  const locale = useTableLocale();

  // Columnas
  const siteAColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'asset_name',
      headerName: 'Equipo',
      width: 160,
    },
    {
      field: 'equip_name',
      headerName: 'Tipo de equipo',
      width: 160,
    },
    {
      field: 'brand_name',
      headerName: 'Marca',
      width: 160,
    },
    {
      field: 'model',
      headerName: 'Modelo',
      width: 160,
    },
    {
      field: 'alias',
      headerName: 'Alias',
      width: 120,
    },
    {
      field: 'location',
      headerName: 'Ubicación',
      width: 180,
    },
    {
      field: 'serial_number',
      headerName: 'Número de serie',
      width: 160,
    },
    {
      field: 'is_active',
      headerName: siteStatusString,
      width: 110,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'updated_at',
      headerName: visitUDateString,
      width: 200,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  return (
    <>
      <span className="dabiWebText"> {assetsString} </span>

      <ModalSiteA
        show={modalSiteAShow}
        onHide={() => setModalSiteAShow(false)}
      />

      <ModalSiteADelete
        show={modalSiteADeleteShow}
        onHide={() => setModalSiteADeleteShow(false)}
      />
      <ModalSiteAUpdate
        show={modalSiteAUpdateShow}
        onHide={() => setModalSiteAUpdateShow(false)}
      />

      <DataGridPro
        pagination
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
        }}
        rows={siteAssetData}
        columns={siteAColumns}
        pageSize={5}
        disableSelectionOnClick
        rowsPerPageOptions={[5]}
        slots={{
          noRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Esta sucursal no tiene equipos asignados.
            </Stack>
          ),
          // toolbar: GridToolbar,
        }}
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
      />
    </>
  );
};
